import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'App',
  computed: _objectSpread({}, mapGetters('application', ['isFetchingFromAPI'])),
  watch: {
    isFetchingFromAPI: function isFetchingFromAPI(bool) {
      if (bool) {
        this.$q.loading.show({
          spinnerSize: 64
        });
      } else {
        this.$q.loading.hide();
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('backbutton', this.handleBackButton, true);
  },
  methods: {
    handleBackButton: function handleBackButton() {
      if (this.$route.path === '/login' || this.$route.path === '/card') {
        navigator.app.exitApp();
      }
    }
  }
};